<template>
  <section class="app-tutorial">
    <div v-if="!$route.params.id" class="app-tutorial-content">
      <CommonAnchorSlider :catalog="catalog" />
      <section class="flex-1 pb-16 ltr:pl-8 rtl:pr-8">
        <ClTutorial
          v-for="(item, index) in tutorialMenu"
          :id="catalog[index].link"
          :key="index"
          :title="item.title"
          :list="item.children"
          class="mt-6 first:mt-0"
          :prefix-path="`/${$route.params.lang}/tutorial`"
        />
      </section>
    </div>
    <div v-else class="app-tutorial-detail">
      <NuxtPage />
    </div>
  </section>
</template>

<script setup lang="ts">
const documentStore = useDocumentStore()
const { fetchTutorialCategory } = documentStore
await fetchTutorialCategory('0', '1')
const { tutorialMenu } = storeToRefs(documentStore)
const catalog = computed(() => {
  return tutorialMenu.value.map((item, index) => {
    return {
      title: item.title,
      link: `tutorial-${index + 1}`
    }
  })
})
</script>

<style lang="scss" scoped>
.app-tutorial {
  @apply relative flex pt-5;
}
.app-tutorial-content {
  @apply flex w-full ltr:pl-9 ltr:pr-17 rtl:pl-17 rtl:pr-9;
}
.app-tutorial-detail {
  @apply flex-1 ltr:pl-17.5 ltr:pr-17 rtl:pl-17 rtl:pr-17.5 pb-16;
}
</style>
